import type { OnboardingUser } from "@/features/onboarding/models";
import { publicAPI } from "@/shared/lib";

interface MergeCustomerIoProfilesParams {
  userCode: OnboardingUser["code"];
  previousCustomerIoId: ReturnType<URLSearchParams["get"]>;
}

export const mergeCustomerIoProfiles = async ({
  userCode,
  previousCustomerIoId,
}: MergeCustomerIoProfilesParams) => {
  return await publicAPI.post(`/patients/${userCode}/analytics/merge`, {
    previousCustomerIoId,
  });
};
